export const KanbanBoardPermissions = {
  
  ViewKanbanBoard: {
    permissionsId: '7e386379-a25f-4566-db07-08dbf16cf01d',
    permissionsName: 'View Kanban Board',
    componentsId: null,
    components: null
  },
};
